<template>
  <div class="d-flex align-center" v-if="!hasLabel">
    <v-btn small icon :href="href" target="_blank" @click.stop="">
      <display-icon-badge-tooltip
        :icon="generateMessage('alerts.predityVision.icon')"
        :tooltip-text="generateMessage('alerts.predityVision.name')"
      />
    </v-btn>
    <v-btn
      v-if="hasSensors"
      small
      icon
      :href="deviceMgtHref"
      target="_blank"
      @click.stop=""
    >
      <display-icon-badge-tooltip
        :icon="generateMessage('alerts.deviceManagement.icon')"
        :tooltip-text="generateMessage('alerts.deviceManagement.name')"
      />
    </v-btn>
  </div>
  <div class="d-flex align-center" v-else>
    <v-btn small text :href="href" target="_blank" @click.stop="">
      <v-icon left>{{ generateMessage('alerts.predityVision.icon') }}</v-icon>
      <span>{{ generateMessage('alerts.predityVision.name') }}</span>
    </v-btn>
    <v-btn
      v-if="hasSensors"
      small
      text
      :href="deviceMgtHref"
      target="_blank"
      @click.stop=""
    >
      <v-icon left>
        {{ generateMessage('alerts.deviceManagement.icon') }}
      </v-icon>
      <span>{{ generateMessage('alerts.deviceManagement.name') }}</span>
    </v-btn>
  </div>
</template>

<script>
import DisplayIconBadgeTooltip from '@/components/displays/DisplayIconBadgeTooltip';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'LinkToCofelyVision',
  components: { DisplayIconBadgeTooltip },
  props: {
    numins: {
      type: [String, Number],
      required: true,
    },
    region: {
      type: String,
      required: false, // semble marcher sans
    },
    hasSensors: {
      type: Boolean,
    },
    deviceType: {
      type: String,
      default: 'Properties',
    },
    hasLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    generateMessage,
  },
  computed: {
    href() {
      return `${process.env.COFELYVISION_BASE_URI}/MyVision/Efficiency/Index/?propertyId=${this.numins}&appsrc=mypredity`;
    },
    baseUri() {
      return process.env.DEVICE_MNGT_BASE_URI;
    },
    deviceMgtHref() {
      if (this.deviceType === 'Heating') {
        return `${this.baseUri}/Heatings/HeatingsManager?propertyId=${this.numins}`;
      }
      return `${this.baseUri}/Sensors/SensorsManager?propertyId=${this.numins}`;
    },
  },
};
</script>

<style scoped></style>
